/**
 * AI 工作區共用常數（前端）
 * 對應後端 app/ee/ai/workspace/
 */

/** 重 AI 操作（fetch 蒐集、生成報告、翻譯、執行 ACTION）統一用 10 分鐘 timeout */
export const LONG_TIMEOUT_MS = 600_000;

/** 單篇 AI 解析 (analyzeItem) — 較短 */
export const ITEM_ANALYZE_TIMEOUT_MS = 120_000;

/** 來源測試（網路抓 RSS / 網頁列表）*/
export const SOURCE_TEST_TIMEOUT_MS = 90_000;

/** URL 預檢（HEAD check）*/
export const URL_PRECHECK_TIMEOUT_MS = 15_000;

/** 對話送 AI 時保留的最近訊息對數（user+assistant 各算 1） */
export const MAX_CHAT_API_MESSAGES = 12;

/** 共用框架提供的端點前綴 */
export const AI_WORKSPACE_API_BASE = '/api/ee/ai/workspace';
